import axios from 'axios'
import { i18n } from '../../main'

const state = { 
    status: null,
    user: null,
    organizationId: null,
    token: localStorage.getItem('token') || null,
    selectedHeaders: null
};

const getters = {
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status,
    loggedUser: state => state.user,
    organizationId: state => state.organizationId,
    organizationSet: state => !!state.organizationId,
    selectedHeaders: state => state.selectedHeaders
};
const actions = {
    login({commit}, {user, authType}) {
        return new Promise((resolve, reject) => {
            if(authType == 'DB')
            {
                commit('auth_request')
                axios.post('User/Login', user)
                .then(response => {
                const token = response.data.token;
                const user = response.data;
                console.log(user);
                localStorage.setItem('token', token);
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
                commit('auth_success', { token: token, user: user })
                resolve(response)
                })
                .catch(err => {
                commit('auth_error')
                console.log(err);
                localStorage.removeItem('token')
                reject(i18n.t('loginFailed'))
                })
            }
            else {
                commit('auth_request')
                axios.get('ADUser/LoginAD')
                .then(response => {
                const token = response.data.token;
                const user = response.data;
                console.log(user);
                localStorage.setItem('token', token);
                //axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
                commit('auth_success', { token: token, user: user })
                resolve(response)
                })
                .catch(err => {
                commit('auth_error')
                console.log(err);
                localStorage.removeItem('token')
                reject(i18n.t('loginFailed'))
                })
            }
            
        })
    },
    logout({commit}) {
        return new Promise((resolve) => {
            commit('logout')
            localStorage.removeItem('token')
            localStorage.removeItem('headers')
            localStorage.removeItem('inputFilter')
            localStorage.removeItem('outputFilter')
            localStorage.removeItem('feeOutputFilter')
            localStorage.removeItem('inputItemsPerPage')
            localStorage.removeItem('outputItemsPerPage')
            localStorage.removeItem('feeOutputItemsPerPage')
            delete axios.defaults.headers.common['Authorization']
            resolve()
        })
    },
    organizationChange({commit}, organizationId) {
        return new Promise((resolve) => {
            commit('organizationChange', { organizationId: organizationId })
            resolve()
        })
    },
    editUser({commit}, user) {
        return new Promise((resolve, reject) => {
                axios.post('User/Save', user)
                .then(response => {
                    if(response.data.message.length == 0) {
                        const user = response.data;
                    commit('editUser', { user: user })
                    resolve(response)
                    }
                    else {
                        reject(response.data.message)
                    }
                })
                .catch(err => {
                console.log(err);
                reject()
                })
                        
        })
    },
    getUsersPermissions({commit}, user) {
        return new Promise((resolve, reject) => {
                axios.post('User/GetUsersPermissions', user)
                .then(response => {
                const user = response.data;
                commit('usersPermissions', { user: user })
                resolve(response)
                })
                .catch(err => {
                console.log(err);
                reject()
                })
                        
        })
    },
};
const mutations = {
    auth_request(state) {
        state.status = 'loading'
    },
    auth_success(state, payload) {
        state.status = 'success'
        state.token = payload.token
        state.user = payload.user
    },
    auth_error(state) {
        state.status = 'error'
    },
    editUser(state, payload) {
        state.user.name = payload.user.name
        state.user.lastname = payload.user.lastname
        state.user.email = payload.user.email
    },
    usersPermissions(state, payload) {
        state.user = payload.user
    },
    organizationChange(state, payload) {
        state.organizationId = payload.organizationId
    },
    logout(state) {
        state.status = null
        state.token = null
        state.user = null
        state.organizationId = null
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
    };